module.exports = __webpack_public_path__ + "images/nedasco0e9ed2ef735e290e151ae23962ba3b55.png";